/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * メディアリストの概要情報を変更する時の POST Body
 * @export
 * @interface PostOurMediaListBody
 */
export interface PostOurMediaListBody {
    /**
     * メディアリスト名
     * @type {string}
     * @memberof PostOurMediaListBody
     */
    mediaListName?: string;
    /**
     * プレスリリース配信元のメール送信者名
     * @type {string}
     * @memberof PostOurMediaListBody
     */
    senderName?: string;
    /**
     * プレスリリース配信元のメールアドレス
     * @type {string}
     * @memberof PostOurMediaListBody
     */
    fromEmail?: string;
}

/**
 * Check if a given object implements the PostOurMediaListBody interface.
 */
export function instanceOfPostOurMediaListBody(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PostOurMediaListBodyFromJSON(json: any): PostOurMediaListBody {
    return PostOurMediaListBodyFromJSONTyped(json, false);
}

export function PostOurMediaListBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostOurMediaListBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mediaListName': !exists(json, 'media_list_name') ? undefined : json['media_list_name'],
        'senderName': !exists(json, 'sender_name') ? undefined : json['sender_name'],
        'fromEmail': !exists(json, 'from_email') ? undefined : json['from_email'],
    };
}

export function PostOurMediaListBodyToJSON(value?: PostOurMediaListBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'media_list_name': value.mediaListName,
        'sender_name': value.senderName,
        'from_email': value.fromEmail,
    };
}

